import {
  Companion_getInstanceidce664s8rcz as Companion_getInstance,
  EventType2bd9gu34l4i61 as EventType,
} from './shared.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareEventTypeFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [EventType_name_getInstance(), EventType_tags_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function EventType_name$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function EventType_name$_get_name_$ref_uu0hgd() {
  return (p0) => p0.k20();
}
function EventType_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function EventType_name$_get_serializer_$ref_ir2vt6() {
  return (p0) => p0.j2j();
}
function EventType_name$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function EventType_name$_get_annotations_$ref_t6a0tu() {
  return (p0) => p0.bz();
}
var EventType_nameClass;
function EventType_name() {
  if (EventType_nameClass === VOID) {
    class $ {
      constructor() {
        EventType_name_instance = this;
        var tmp = this;
        tmp.t8l_1 = lazy(EventType_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u8l_1 = lazy(EventType_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v8l_1 = lazy(EventType_name$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.t8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventType_name$_get_name_$ref_uu0hgd(), null);
        return tmp0.f2();
      }
      w8l(receiver) {
        return receiver.x8l_1;
      }
      m2j(receiver) {
        return this.w8l(receiver instanceof EventType() ? receiver : THROW_CCE());
      }
      z8l(receiver, value) {
        return receiver.a8m(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof EventType() ? receiver : THROW_CCE();
        return this.z8l(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventType_name$_get_serializer_$ref_ir2vt6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v8l_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventType_name$_get_annotations_$ref_t6a0tu(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'EventType_name', VOID, VOID, [SerializableProperty()]);
    EventType_nameClass = $;
  }
  return EventType_nameClass;
}
var EventType_name_instance;
function EventType_name_getInstance() {
  if (EventType_name_instance === VOID)
    new (EventType_name())();
  return EventType_name_instance;
}
function EventType_tags$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function EventType_tags$_get_name_$ref_lbz301() {
  return (p0) => p0.k20();
}
function EventType_tags$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function EventType_tags$_get_serializer_$ref_w3ojag() {
  return (p0) => p0.j2j();
}
function EventType_tags$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function EventType_tags$_get_annotations_$ref_fd586c() {
  return (p0) => p0.bz();
}
var EventType_tagsClass;
function EventType_tags() {
  if (EventType_tagsClass === VOID) {
    class $ {
      constructor() {
        EventType_tags_instance = this;
        var tmp = this;
        tmp.b8m_1 = lazy(EventType_tags$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c8m_1 = lazy(EventType_tags$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d8m_1 = lazy(EventType_tags$annotations$delegate$lambda);
        this.e8m_1 = emptySet();
        this.f8m_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.b8m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, EventType_tags$_get_name_$ref_lbz301(), null);
        return tmp0.f2();
      }
      w8l(receiver) {
        return receiver.y8l_1;
      }
      m2j(receiver) {
        return this.w8l(receiver instanceof EventType() ? receiver : THROW_CCE());
      }
      g8m(receiver, value) {
        return receiver.a8m(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof EventType() ? receiver : THROW_CCE();
        return this.g8m(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c8m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, EventType_tags$_get_serializer_$ref_w3ojag(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d8m_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, EventType_tags$_get_annotations_$ref_fd586c(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'EventType_tags', VOID, VOID, [SerializableProperty()]);
    EventType_tagsClass = $;
  }
  return EventType_tagsClass;
}
var EventType_tags_instance;
function EventType_tags_getInstance() {
  if (EventType_tags_instance === VOID)
    new (EventType_tags())();
  return EventType_tags_instance;
}
//region block: exports
export {
  prepareEventTypeFields as prepareEventTypeFields24sy6awcbqv5s,
};
//endregion

//# sourceMappingURL=EventTypeFields.mjs.map
